import { Activity } from "@mapmycustomers/shared/types/entity";

import isAutoEmailActivity from "./isAutoEmailActivity";

const isBulkEmailParentActivity = (
  activity?: Activity
): activity is Activity & Required<Pick<Activity, "childCount">> =>
  isAutoEmailActivity(activity) && !!activity?.childCount;

export default isBulkEmailParentActivity;
